export const DIALOG_ERROR_OPEN = "DIALOG_ERROR_OPEN";
export const DIALOG_ERROR_CLOSE = "DIALOG_ERROR_CLOSE";
export const DIALOG_LOGIN_OPEN = "DIALOG_LOGIN_OPEN";
export const DIALOG_LOGIN_CLOSE = "DIALOG_LOGIN_CLOSE";
export const DIALOG_REGISTER_OPEN = "DIALOG_REGISTER_OPEN";
export const DIALOG_REGISTER_CLOSE = "DIALOG_REGISTER_CLOSE";
